import "./index.scss";
import { FilterItem, FilterListProps, FilterState } from "./types";
import CfList from "components/List/CfList";
import Filter from "components/Filter";
import React, { Suspense, useCallback, useMemo, useState } from "react";
import recursiveRender from "utilities/recursiveRender";

const FilterList = ({
  columnLayout,
  listItem,
  id,
  isExclusive,
}: FilterListProps) => {
  const startingState: FilterState = listItem.reduce((filtersState, filter) => {
    return {
      [filter.id]: { status: false, label: filter.label },
      ...filtersState,
    };
  }, {});

  const [filters, setFilters] = useState(startingState);

  const filteredItems = useMemo<FilterItem[]>(() => {
    if (
      Object.keys(filters).some((filter) => {
        return filters[filter].status === true;
      })
    ) {
      return listItem.reduce<FilterItem[]>(
        (accItems, filter) =>
          filters[filter.id].status === false
            ? [...accItems]
            : [...accItems, ...filter.content],
        [],
      );
    }

    return listItem.reduce<FilterItem[]>(
      (accItems, filter) => [...accItems, ...filter.content],
      [],
    );
  }, [filters, listItem]);

  const updateFilters = useCallback(
    (filterState: boolean, filterId: string) => {
      const prevFilters = isExclusive
        ? Object.entries(filters).reduce(
            (filtersObj, [fId, fOptions]) => ({
              ...filtersObj,
              [fId]: { ...fOptions, status: false },
            }),
            {},
          )
        : filters;

      setFilters({
        ...prevFilters,
        [filterId]: {
          ...filters[filterId],
          status: filterState,
        },
      });
    },
    [filters, isExclusive],
  );

  const uniqueFilteredItems = useMemo(
    () =>
      filteredItems.reduce<FilterItem[]>((accItems, filteredItem) => {
        return accItems.some((item) => {
          return item.id === filteredItem.id;
        })
          ? [...accItems]
          : [...accItems, filteredItem];
      }, []),
    [filteredItems],
  );

  return (
    <div className="FilterList">
      <div className="FilterList__label-section wrapContent wrapContent-lg-lg">
        <div className="FilterList__label-section__wrap">
          {Object.keys(filters).map((filter) => (
            <div
              className="FilterList__label-section__item"
              key={filter}
              data-testid="filterButton"
            >
              <Filter
                onClick={() => updateFilters(!filters[filter].status, filter)}
                title={filters[filter].label}
                isPressed={filters[filter].status}
              />
            </div>
          ))}
        </div>
      </div>
      <div className="FilterList__items-section">
        <CfList
          columnLayout={columnLayout}
          id={`${id}-list`}
          contentful_id="filter-list"
          customClass=""
          style={null}
          activeSlider={null}
        >
          {recursiveRender({ cfComponent: uniqueFilteredItems })}
        </CfList>
      </div>
    </div>
  );
};

export default FilterList;
